// @flow

import { createSelector } from 'reselect';

function getFriends(allFriends, allRequests, group) {
  const groupRequests = group ? allRequests.filter(req => group.members.includes(req.id)) : [];
  return [...allFriends, ...groupRequests];
}

const manageFriendsSelector = createSelector(
  (state: GlobalState) => Object.values(state.friends.friends),
  (state: GlobalState) => Object.values(state.friendRequests.friendRequests),
  (state, groupId) => state.friendGroups.groups[groupId],
  getFriends
);

export default manageFriendsSelector;
